import ActiveIcon from "@/assets/icons/ActiveGreenIcon.svg";

import QuestionCircle from "@/assets/icons/QuestionCircle.svg";
import { TResponseOrderDetails } from "@/types/projectType";

const ProjectManagementHeader = ({ data }: { data: TResponseOrderDetails }) => {
  return (
    <div className="mt-[60px] flex justify-between items-center">
      <div className="flex flex-col md:flex-row md:items-center gap-3">
        <h4 className="text-xl truncate max-w-[312px] leading-7 tracking-[-1%] md:text-xl font-semibold">
          {data?.projectName}
        </h4>
        <div className="self-start md:self-auto">
          <div className="inline-flex bg-[#ECFDF3] text-[#027143] text-xs px-2 py-1 items-center gap-1 rounded-full whitespace-nowrap">
            <ActiveIcon />
            <span>Active</span>
          </div>
        </div>
      </div>
      {/* <button className="md:flex gap-1 items-center text-sm text-[#667085] font-medium py-[6px] px-3 border border-[#DEDBDB] rounded-2xl hidden">
        <QuestionCircle /> Help
      </button> */}
    </div>
  );
};

export default ProjectManagementHeader;
